<template>
  <div class="footer">
    <div v-if="!tiny">
      <TheFooterLogos class="box" />

      <b-container fluid class="mt-4">
        <b-row>
          <b-col sm="12" md="4" class="pl-0 pr-0 pr-md-2">
            <div class="box p-3">
              <TheFooterImages :title="$t('footer.follow_us')">
                <SocialIcons></SocialIcons>
              </TheFooterImages>
            </div>
          </b-col>

          <div class="separation"></div>

          <b-col sm="12" md="4" class="pl-0 pr-0 pl-md-2 pr-md-2">
            <div class="box p-3">
              <TheFooterLinks
                :title="$t('footer.about')"
                :links="aboutLinks"
                icon="angle-right"
              ></TheFooterLinks>
            </div>
          </b-col>

          <div class="separation"></div>

          <b-col sm="12" md="4" class="pr-0 pl-0 pl-md-2">
            <div class="box p-3">
              <TheFooterLinks
                :title="$t('footer.information')"
                :links="informationLinks"
                icon="angle-right"
              ></TheFooterLinks>
            </div>
          </b-col>
        </b-row>

        <b-row sm="0" md="1" class="separator mt-3 mb-4">
          <b-col>
            <div></div>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="4">
            <TheFooterContact
              :title="$t('footer.customer_service')"
              :phone="phoneCustomerService"
              :body="$t('footer.opening_hours')"
              :email="$t('footer.customer_service_email')"
              :info="{ to: { name: 'customer-service' }, text: $t('footer.customer_service') }"
            />
          </b-col>

          <b-col cols="12" md="4" class="mt-md-0 mt-4">
            <TheFooterImages :title="$t('footer.payment_methods')">
              <component
                v-for="(payment, indexPayment) in paymentsSvgComponents"
                v-bind:is="payment"
                :key="indexPayment"
                class="mx-3 mb-3"
              ></component>
            </TheFooterImages>
          </b-col>

          <b-col cols="12" md="4" class="mt-md-0 mt-4">
            <b-col>
              <TheFooterImages :title="$t('footer.download_app')">
                <div class="mx-2 mb-2">
                  <div class="text-uppercase font-weight-bold text-black-50">
                    {{ $t("footer.soon") }}
                  </div>
                  <img src="@/static/app/googleplay.jpg" />
                </div>
                <div class="mx-2 mb-2">
                  <div class="text-uppercase font-weight-bold text-black-50">
                    {{ $t("footer.soon") }}
                  </div>
                  <SVGAppStore />
                </div>
              </TheFooterImages>
            </b-col>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <b-container fluid class="mt-4">
      <b-row class="copyright mt-4">
        <b-col>&copy; Vooy Market by GLOBAL STORE PH PTE. LTD.</b-col>
        <b-col class="text-right">
          <router-link :to="{name: 'terms_conditions'}">
            {{ $t('footer.terms_and_conditions') }}
          </router-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>


<script>
import SocialIcons from "@/components/SocialIcons";

import SVGVisa from "@/static/payment/visa.svg";
import SVGAmericanExpress from "@/static/payment/americanexpress.svg";
import SVGMastercard from "@/static/payment/mastercard.svg";
import SVGPaypal from "@/static/payment/paypal.svg";
import SVGBankTransfer from "@/static/payment/bank_transfer.svg";

import SVGAppStore from "@/static/app/appstore.svg";

import TheFooterContact from "@/components/TheFooterContact";
import TheFooterLinks from "@/components/TheFooterLinks";
import TheFooterImages from "@/components/TheFooterImages";
import TheFooterLogos from "@/components/TheFooterLogos";

export default {
  name: "the-footer",
  components: {
    TheFooterContact,
    TheFooterLinks,
    TheFooterImages,
    TheFooterLogos,
    SVGVisa,
    SVGAmericanExpress,
    SVGMastercard,
    SVGBankTransfer,
    SVGPaypal,
    SVGAppStore,
    SocialIcons,
  },
  props: {
    tiny: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      phoneCustomerService: this.$phoneCustomerService,
      followSvgComponents: [
        {
          svg: "SVGFacebook",
          url: "https://www.facebook.com/MedikaOnlinePro/",
        },
        {
          svg: "SVGTwitter",
          url: "https://twitter.com/Medika_Online",
        },
        {
          svg: "SVGInstagram",
          url: "https://www.instagram.com/medikaonlinepro/",
        },
        {
          svg: "SVGYoutube",
          url: "/",
        },
      ],
      paymentsSvgComponents: [
        "SVGVisa",
        "SVGAmericanExpress",
        "SVGMastercard",
        "SVGPaypal",
        "SVGBankTransfer",
      ],
    };
  },
  computed: {
    aboutLinks() {
      return [
        {
          route: { name: "what-is-vooymarket" },
          text: this.$t("footer.what_is_medika_online"),
        },
        {
          route: { name: "how-does-it-work" },
          text: this.$t("footer.how_does_it_work"),
        },
        {
          route: { name: "listpharmacies" },
          text: this.$t("footer.list_pharmacies"),
        },
        {
          path: "https://pro.globalstorepharma.com/",
          name: "proglobalstorepharma",
          text: this.$t("footer.sell_on_medika"),
        },
        {
          route: { name: "under_construction" }, // clinic-login
          text: this.$t("footer.clinic"),
        },
        {
          route: { name: "under_construction" }, // medic-login
          text: this.$t("footer.medic"),
        },
        {
          route: { name: "insurance-login" },
          path: "https://my.globalstorepharma.com/",
          name: "myglobalstorepharma",
          text: this.$t("footer.insurance"),
        },
      ];
    },
    informationLinks() {
      return [
        {
          route: { name: "userhistorial" },
          text: this.$t("footer.my_orders"),
        },
        {
          route: { name: "legal" },
          text: this.$t("footer.legal"),
        },
        {
          route: { name: "terms_conditions" },
          text: this.$t("footer.terms_and_conditions_link"),
        },
        {
          route: { name: "cookies" },
          text: this.$t("footer.cookies"),
        },
        {
          route: { name: "privacy" },
          text: this.$t("footer.privacy"),
        },
        {
          route: { name: "terms_sale" },
          text: this.$t("footer.terms_sale"),
        },
        {
          route: { name: "offers" },
          text: this.$t("footer.offers"),
        },
      ];
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        footer: {
          about: "About us",
          what_is_medika_online: "What is Vooy Market?",
          list_pharmacies: "Pharmacy directory",
          how_does_it_work: "How does it work?",
          sell_on_medika: "I am a pharmacy (Sell on Gobal Store P.H.)",
          clinic: "I am a clinic / hospital",
          medic: "I am a MD",
          insurance: "I am an insurer",
          customer_service: "Customer Service",
          customer_service_email: "contact@vooymarket.com",
          opening_hours: "Monday - Friday 9:00 to 19:00",
          terms_and_conditions: "Terms and conditions of use",
          information: "Information",
          my_orders: "My orders",
          legal: "Legal",
          terms_and_conditions_link: "Terms and conditions of use",
          cookies: "Cookies",
          privacy: "Privacy notice",
          terms_sale: "Terms of sale",
          offers: "Offers",
          download_app: "Download our app",
          payment_methods: "Payment Methods",
          follow_us: "Follow us",
          soon: "Soon",
        },
      },
    },
  },
};
</script>


<style scoped lang="scss">
.title {
  font-size: 1.2rem;
  font-weight: bold;
  text-transform: uppercase;
}

.footer-img {
  display: inline-block;
}

.footer .copyright {
  font-size: 0.8rem;
  border-top: 1px solid $grey2-color;

  padding-top: 1rem;
}

.footer {
  font-size: 0.7rem;
}

.footer a {
  color: $footer-font-color;
  text-decoration: none;
}

.footer a:hover {
  color: $footer-font-color;
  text-decoration: underline;
}

.footer .separator {
  background-color: $corp-color2;
  height: 2.5rem;
  /* weight: 100%; */
}

.footer .box {
  height: 100%;
  border: 1px solid $grey2-color;
}

.footer .separation {
  height: 20px;

  @include media-breakpoint-down(md) {
    width: 100%;
  }
}

.image-footer {
  fill: $grey5-color;
  height: 40px;
  width: 40px;
}

.image-footer:hover {
  fill: $corp-color2;
}
</style>
